class NsCartCrossSell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    this.track = this.querySelector('[data-ns-track]');
    this.prevButton = this.querySelector('[data-ns-prev]');
    this.nextButton = this.querySelector('[data-ns-next]');

    if (!this.track) return;

    const items = Array.from(
      this.querySelectorAll('[data-ns-item]')
    );

    if (!items.length) return;

    this.randomize(items);
    this.bindControls();
  }


  randomize(items) {
    const maximum =
      Math.min(
        Number(this.dataset.show || 4),
        items.length
      );

    const shuffled = [...items];


    /* Fisher-Yates shuffle */

    for (let i = shuffled.length - 1; i > 0; i--) {
      const randomIndex =
        Math.floor(Math.random() * (i + 1));

      [
        shuffled[i],
        shuffled[randomIndex]
      ] = [
        shuffled[randomIndex],
        shuffled[i]
      ];
    }


    /* Randomize DOM order */

    shuffled.forEach((item) => {
      this.track.appendChild(item);
    });


    /*
      Only hide extras AFTER JavaScript
      successfully initializes.

      Mobile fallback therefore remains visible.
    */

    shuffled.forEach((item, index) => {
      item.hidden = index >= maximum;
    });
  }


  bindControls() {
    this.prevButton?.addEventListener(
      'click',
      () => this.move(-1)
    );

    this.nextButton?.addEventListener(
      'click',
      () => this.move(1)
    );
  }


  move(direction) {
    const item =
      this.track.querySelector(
        '[data-ns-item]:not([hidden])'
      );

    if (!item) return;

    const trackStyle =
      getComputedStyle(this.track);

    const gap =
      parseFloat(trackStyle.columnGap) || 8;

    const distance =
      item.getBoundingClientRect().width + gap;

    this.track.scrollBy({
      left: distance * direction,
      behavior: 'smooth'
    });
  }
}


if (!customElements.get('ns-cart-cross-sell')) {
  customElements.define(
    'ns-cart-cross-sell',
    NsCartCrossSell
  );
}